//@ vendor
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

//@ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const FormattedDescription = require('components/commons/FormattedDescription/FormattedDescription');
const { formatAmount } = require('utilities/currencyHelper');
const urlHelper = require('utilities/urlHelper');
const globalAssetClass = require('utilities/globalAssetClass');

//@ components
const TabbedBoxContent = require('components/commons/tabbedBox/tabbedBoxContent/tabbedBoxContent');
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling'
const { FUND_GLOSSARY } = require('constants/flagBasedFeatures')

require('./TabFees.scss');


const TabFees = ({ fund, flagBasedFeatures, catalogueDetails }) => {

    const labelSearchName = flagBasedFeatures.get(FUND_GLOSSARY)
        ? <FormattedDescription value="fundsCard-updatedInformationDisclaimer" />
        : <FormattedDescription value="fundsCard-updatedInformationDisclaimerNoGlossary" />

    const isFundsNetAssetsValue = fund.fundNetAssetValues;
    const ongoingCostsOtherCosts = catalogueDetails ? catalogueDetails.ter : 0;
    const fundNetValue = isFundsNetAssetsValue ? `${formatAmount(isFundsNetAssetsValue[0].dayEndValue)} ${isFundsNetAssetsValue[0].currencyId}` : '-';
    const managementFee = catalogueDetails ? catalogueDetails.mgmtFeeExAnte : 0;
    const infoManagerSection =
        !!fund && !!fund.managerList
            ? fund.managerList.map((manager) => (
                <div
                    className="information__manager"
                    key={manager.displayPreference}
                >
                    <p className="manager--name">
                        {manager.givenName} {manager.familyName}
                    </p>
                    <p className="manager--incorporation">
                        {formatText("fundsCard-administratorJoined")}
                        &nbsp;
                        {moment(manager.startDate).format("DD MMM YYYY")}
                    </p>
                </div>
            )) : null;
    const redemptionFee = catalogueDetails && catalogueDetails.redemptionFee ? catalogueDetails.redemptionFee : 0;
    return (
        <TabbedBoxContent visible>
            <section className="tabfees">
                <div className="row">
                    <div className="col-md-8 col-xs-12 tabfees__commissions">
                        <h3 className="comissions--title">{formatText('fundsCard-annualFeesTitle')}</h3>
                        <p className="comissions--description">
                            <FormattedText value="fundsCard-annualFeesDescription" />
                        </p>
                        <h2 className="comissions--total">{formatAmount(managementFee, null, 2, !Number.isInteger(managementFee))}
                            <span className="total--percent">%</span>
                        </h2>
                        <h4 className="comissions--subtitle">{formatText('fundsCard-administrationFeeMax')}</h4>
                        <div className="comissions--expenses">

                            <div className="expenses__box">
                                <div className="expenses--description">{formatText('fundsCard-ongoingCharge')}</div>
                                <div className="expenses--quantity">{formatAmount(ongoingCostsOtherCosts && ongoingCostsOtherCosts, null, 2, !Number.isInteger(ongoingCostsOtherCosts))}%</div>
                            </div>
                            {/*
                        //TODO Héctor Arce de las Heras needs toDO
                        <div className="expenses__box">
                            <div className="expenses--description">{formatText('fundsCard-depositFeeMax')}</div>
                            <div className="expenses--quantity">0,15%</div>
                        </div>

                        <div className="expenses__box">
                            <div className="expenses--description">{formatText('fundsCard-successFeeMax')}</div>
                            <div className="expenses--quantity">{formatText('fundsCard-feeAssimilated', [formatAmount(0.19)])}</div>
                        </div>

                        <div className="expenses__box">
                            <div className="expenses--description">{formatText('fundsCard-feeNetMax')}</div>
                            <div className="expenses--quantity">{formatText('fundsCard-feeNonExistent')}</div>
                        </div>

                        <div className="expenses__box">
                            <div className="expenses--description">{formatText('fundsCard-distributionMax')}</div>
                            <div className="expenses--quantity">{formatText('fundsCard-feeNonExistent')}</div>
                        </div>
                        */}

                            <div className="expenses__box expenses__box--separator">
                                <div className="expenses--description">{formatText('fundsCard-feeSubscriptionMax')}</div>
                                <div className="expenses--quantity">
                                    {
                                        fund.purchaseDetails && fund.purchaseDetails[0].frontLoad.value && fund.purchaseDetails[0].frontLoad.value > 0
                                            ? <span>{formatAmount(fund.purchaseDetails[0].frontLoad.value, null, 2, !Number.isInteger(fund.purchaseDetails[0].frontLoad.value))}%</span>
                                            : <span>{formatText('fundsCard-feeNonExistent')}</span>
                                    }
                                </div>
                            </div>
                            <div className="expenses__box">
                                <div className="expenses--description">
                                    {!!parseFloat(redemptionFee)
                                        ? formatText('fundsCard-redemptionFeeLabel')
                                        : formatText('fundsCard-feeWithdrawMax')}
                                </div>
                                <div className="expenses--quantity">
                                    {!!parseFloat(redemptionFee)
                                        ? <span>
                                            {formatAmount(
                                                redemptionFee,
                                                null,
                                                2,
                                                !Number.isInteger(redemptionFee)
                                            )}%
                                        </span>
                                        : <span>{formatText('fundsCard-feeNonExistent')}</span>}
                                </div>
                            </div>
                            <div className="expenses__box expenses__box--separator">
                                <div className="expenses--description">{formatText('fundsCard-initialInvestmentMin')}</div>
                                <div className="expenses--quantity">
                                    {
                                        fund.minimumDetails
                                            ? formatAmount(fund.minimumDetails.minimumAmount) + ' ' + fund.custom.customPurchaseCurrency
                                            : <span>{formatText('fundsCard-feeNonExistent')}</span>
                                    }
                                </div>
                            </div>
                            <div className="expenses__box">
                                <div className="expenses--description">{formatText('fundsCard-deposits')}</div>
                                <div className="expenses--quantity">
                                    {
                                        fund.minimumDetails && fund.minimumDetails.minimumAmountAdditional && fund.minimumDetails.minimumAmountAdditional > 0
                                            ? <span>{formatAmount(fund.minimumDetails.minimumAmountAdditional)} {fund.custom.customPurchaseCurrency}</span>
                                            : <span>{formatText('fundsCard-feeNonExistent')}</span>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    { fund.administratorCompany &&
                        <div className="col-md-4 col-xs-12 tabfees__information">
                            <div className="information__card">
                                <h3 className="information--title">{fund.administratorCompany.name}</h3>
                                <p className="information--address">{fund.administratorCompany.addressLine1}</p>
                                <p className="information--phone">{fund.administratorCompany.phone}</p>
                                {fund.administratorCompany.homepage !== undefined && <p className="information--website">
                                    <a className="website--url" href={fund.administratorCompany.homepage}>
                                        {urlHelper.getDomainFromUrl(fund.administratorCompany.homepage)}
                                    </a>
                                </p>}

                                <hr className="information__separator"></hr>

                                <div className="information__box">
                                    <span className="category--title">{formatText('fundsCard-category')}</span>
                                    <span className="category--description">
                                        { fund.benchmark
                                            ? <span> {globalAssetClass(fund.benchmark.find(b => b.type === 'Category').globalAssetClassId)}</span>
                                            : '-'
                                        }
                                    </span>
                                </div>
                                <div className="information__box">
                                    <span className="heritage--title">{formatText('fundsCard-netAssetsValue')}</span>
                                    <span className="heritage--description">
                                        {fundNetValue}
                                    </span>
                                </div>
                                <div className="information__box">
                                    <span className="totalfunds--title">{formatText('fundsCard-fundNetAssetsValue')}</span>
                                    <span className="totalfunds--description">
                                        {fundNetValue}
                                    </span>
                                </div>
                                <div className="information__box">
                                    <span className="constitution--title">{formatText('fundsCard-inceptionDate')}</span>
                                    <span className="constitution--description">{moment(fund.inceptionDate).format('DD MMM YYYY')}</span>
                                </div>
                                <div className="information__box">
                                    <span className="UCITS--title">{formatText('fundsCard-UCITS')}</span>
                                    <span className="UCITS--description">
                                        {!!fund.fundAttributes && fund.fundAttributes.uCITS === 'true'
                                            ? formatText('fundsCard-yes')
                                            : formatText('fundsCard-no')
                                        }
                                    </span>
                                </div>
                                <h3 className="information--title">{formatText('fundsCard-administrators')}</h3>
                                { infoManagerSection }
                            </div>
                        </div>
                    }
                    <div className="col-md-12 col-xs-12 tabfees__information ">
                        <p className="information__card information__card--footer">
                            {labelSearchName}
                        </p>
                    </div>
                </div>
            </section>
        </TabbedBoxContent>
    );
}


TabFees.propTypes = {
    fund: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    catalogueDetails: PropTypes.object.isRequired
};

module.exports = withFeatureToggling(TabFees)
